import { Injectable } from '@angular/core';
import { ApiService } from "../api-service/api-service";

/*
  Generated class for the LotteryServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MoveshopService {

  constructor(public apiService: ApiService) {

  }

  //获取游击店活动列表
  getShops(params: any) {
    let seq = this.apiService.get('v1/moveshop', params).share();
    seq.subscribe((res: any) => {

    }, err => {
      console.error(err);
    });

    return seq;
  }

  //获取游击店商品列表
  getMoveshopSales(params: any) {
      params.id='sale';
    let seq = this.apiService.get('v1/moveshop/sale', params).share();
    seq.subscribe((res: any) => {

    }, err => {
      console.error(err);
    });

    return seq;
  }


}



// WEBPACK FOOTER //
// ./src/providers/data-service/moveshop-service.ts